import linkifyHtml from 'linkify-html';

const ignorePatterns = [/\d+\.Select$/, /\w+\.properties$/];

export default function safeLinkifyHtml(html: string): string {
  try {
    return linkifyHtml(html, {
      rel: 'noreferrer',
      target: '_blank',
      truncate: 42,
      validate: {
        url: value =>
          !ignorePatterns.some(ignorePattern => ignorePattern.test(value)),
      },
    });
  } catch {
    return html;
  }
}
